import { useCallback } from 'react';
import { clearStorageForLogout } from '../util/startPage';

export const useAuth = () => {
    const clearAuthState = useCallback(() => {
        // Clear all authentication-related items from localStorage
        const authItems = [
            'token',
            'currentBusiness',
            'googleCredential',
            'selectedBusiness',
            'providerUser'
        ];

        authItems.forEach(item => localStorage.removeItem(item));

        // Remove session data while keeping account start-page preferences.
        clearStorageForLogout();

        // Clear any cookies related to authentication
        document.cookie.split(";").forEach(cookie => {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
    }, []);

    return { clearAuthState };
};
